import { render, staticRenderFns } from "./detail_personaltrain.vue?vue&type=template&id=1976c676&scoped=true&"
import script from "./detail_personaltrain.vue?vue&type=script&lang=js&"
export * from "./detail_personaltrain.vue?vue&type=script&lang=js&"
import style0 from "./detail_personaltrain.vue?vue&type=style&index=0&id=1976c676&scoped=true&lang=css&"
import style1 from "./detail_personaltrain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976c676",
  null
  
)

export default component.exports